import { forwardRef, Ref } from "react";
import classNames from "classnames";

// components
import { LocationSpaceDetailsCardContent, LocationSpaceDetailsCardHeaderRight } from "./SubComponents";
import Collapse from "@/components/Collapse";
import RestrictedView from "@/components/RestrictedView";

// helpers
import { getChildrenByDisplayName } from "@/helpers/subComponentsUtils";

// interfaces
import { ILocationSpaceDetailsCard } from "./ILocationSpaceDetailsCard";

// assets
import styles from "@/assets/styles/containers/location-space-details-card.module.scss";


function LocationSpaceDetailsCard(props: ILocationSpaceDetailsCard, ref: Ref<HTMLElement>) {
  const {
    title,
    subtitle,
    children,
    className,
    isMobileView,
    isCollapsing,
    isSmallText,
    isRestricted,
    restrictedTitle,
    restrictedSubtitle,
    restrictedButtonText,
    onRestrictedButtonClick,
    ...rest
  } = props;

  const content = getChildrenByDisplayName(children, LocationSpaceDetailsCardContent.displayName);
  const headerRight = getChildrenByDisplayName(children, LocationSpaceDetailsCardHeaderRight.displayName);

  const renderContent = () => (<>
    { (!isCollapsing && (title || subtitle)) &&
      <div className={classNames(
        styles["locl-location-space-details-card__header"],
        { [styles["locl-location-space-details-card__header__mobile"]]: isMobileView },
        { [styles["locl-location-space-details-card__header__small-text"]]: isSmallText }
      )}>
        {
          (title || subtitle) && (
            <div className={styles["locl-location-space-details-card__header__left"]}>
              { title && <h3 className={styles["locl-location-space-details-card__header__title"]}>{ title }</h3> }
              { !!subtitle && <span className={styles["locl-location-space-details-card__header__subtitle"]}>{ subtitle }</span> }
            </div>
          )
        }
        { headerRight }
      </div>
    }
    <div className={styles["locl-location-space-details-card__body"]}>
      { content }
      {
        isRestricted && (
          <RestrictedView
            title={restrictedTitle}
            subtitle={restrictedSubtitle}
            buttonText={restrictedButtonText || ""}
            onButtonClick={() => onRestrictedButtonClick && onRestrictedButtonClick()}
          />
        )
      }
    </div>
  </>)

  return (
    <section className={classNames(styles["locl-location-space-details-card"], className)} { ...rest } ref={ref}>
      {
        isCollapsing
          ? <Collapse
            className={styles["locl-location-space-details-card__collapse"]}
            defaultActiveKey={[]}
            collapsible="header"
          >
            <Collapse.Panel
              header={<h3 className={styles["locl-location-space-details-card__header__title"]}>{ title }</h3>}
              key="1"
              showArrow
            >
              { renderContent()}
            </Collapse.Panel>
          </Collapse>
          : renderContent()
      }
    </section>
  );
}

export default forwardRef(LocationSpaceDetailsCard);
